import React, { Component } from "react";
import CustomLink from '../common/CustomLink';

class TileLoader extends Component {
    constructor(params) {
        super(params);
    }


    render() {
        const { linkProps } = this.props;
        return (
            <div className={"card card-loading-container " + this.props.tileclass}>
                <div className="card-header">
                    <div className="row">
                        <div className="col-12">
                            <div className="card-heading">{this.props.tilename}</div>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-12 align-self-center">
                            <div className="spinner">
                                <div className="bounce1" />
                                <div className="bounce2" />
                                <div className="bounce3" />
                            </div>
                        </div>
                    </div>
                </div>
                {linkProps && <CustomLink linkProps={{ ...linkProps }}><span /></CustomLink>}
            </div>
        );
    }
}

export default TileLoader;